
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bcks/selection",
      function () {
        return require("private-next-pages/bcks/selection.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bcks/selection"])
      });
    }
  